import React, { useState, useEffect, useCallback } from 'react';
import { useReactFlow } from 'reactflow';
import {
  ReactFlow,
  Background,
  addEdge,
  useEdgesState,
  useNodesState,
  type Edge,
  type Node,
  type OnConnect,
} from 'reactflow';

import 'reactflow/dist/style.css';
import './Workflow.css';
import CargandoSpinner from '../0. Utilidades/loadingSpinner';
import { BsTextareaResize } from "react-icons/bs";


const initialEdges: Edge[] = [
  {
    id: 'e2-3',
    source: '2',
    target: '3',
    type: 'step',
    animated: true,
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
  },
  {
    id: 'e2-4',
    source: '2',
    target: '4',
    type: 'step',
    animated: true,
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
    label: <>Es Maestra</>,
  },
  {
    id: 'e4-5',
    source: '4',
    target: '5',
    type: 'step',
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
    label: <>Aprueba Gestora de Comunidades</>,
  },
  {
    id: 'e1-2',
    source: '1',
    target: '2',
    type: 'step',
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
  },
  {
    id: 'e1-6',
    source: '1',
    target: '6',
    type: 'step',
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
  },
  {
    id: 'e6-7',
    source: '6',
    target: '7',
    type: 'step',
    animated: true,
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
  },
  {
    id: 'e3-7',
    source: '3',
    target: '7',
    type: 'step',
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
  },
  {
    id: 'e7-8',
    source: '7',
    target: '8',
    type: 'step',
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
    label: <>Aprueba Psicóloga</>,
  },
  {
    id: 'e8-5',
    source: '8',
    target: '5',
    type: 'step',
    style: { stroke: '#000' },
    markerEnd: { type: 'arrowclosed', width: 20, height: 20, color: '#000' },
    label: <>Aprueba Curso</>,
  },
];

function Workflow() {
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [loading, setLoading] = useState(true);

  const onConnect: OnConnect = useCallback(
    (params) => setEdges((eds) => addEdge({ ...params, type: 'step', animated: true }, eds)),
    [setEdges]
  );

  const { fitView } = useReactFlow();

useEffect(() => {
  const handleResize = () => fitView({ padding: 0.2 });

  window.addEventListener('resize', handleResize);
  handleResize(); // initial fit

  return () => window.removeEventListener('resize', handleResize);
}, [fitView, nodes, edges]);

useEffect(() => {
  if (!loading) {
    const timeout = setTimeout(() => {
      fitView({ padding: 0.2 });
    }, 500); // adjust delay if needed

    return () => clearTimeout(timeout);
  }
}, [loading, fitView]);


const handleManualResize = () => {
  setTimeout(() => {
    fitView({ padding: 0.2 });
  }, 300);
};


  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_BASE_API}api/workflow/`;
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error(`Error: ${response.statusText}`);
        const data = await response.json();

        const maestras = data.maestras || 0;
        const comunidad = data.comunidades_maestra || 0;
        const comunidades = data.comunidades_interesada || 0;
        const curso = data.maestras_en_curso_activo || 0;
        const postulante = data.postulantes_activas || 0;

        const generatedNodes: Node[] = [
          { id: '1', position: { x: 0, y: 0 }, data: { label: 'Sitio Web' }, type: 'input' },
          { id: '2', position: { x: 0, y: 100 }, data: { label: 'Formulario' } },
          { id: '6', position: { x: -200, y: 100 }, data: { label: 'Convocatoria' } },
          { id: '3', position: { x: 0, y: 200 }, data: { label: <>Interesadas<br />{comunidades}</> }, sourcePosition: 'left' },
          { id: '4', position: { x: 200, y: 200 }, data: { label: <>Solicitudes Maestras<br />{comunidad}</> } },
          { id: '5', position: { x: 200, y: 400 }, data: { label: <>Comunidad Maestras<br />{maestras}</> } },
          { id: '7', position: { x: -200, y: 200 }, data: { label: <>Postulaciones<br />{postulante}</> } },
          { id: '8', position: { x: -200, y: 400 }, data: { label: <>Alumnas Curso<br />{curso}</> }, sourcePosition: 'right' },
        ];

        setNodes(generatedNodes);
      } catch (error) {
        console.error('Error fetching workflow counts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, [setNodes]);

  return (
    <div id="workflow">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem',marginBottom: '.5rem' }}>
  <h3 style={{ margin: 0 }}>Flujo de Información</h3>
  <button
    onClick={handleManualResize}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'green',
      fontSize: '1.2rem',

    }}
    title="Reajustar vista"
  >
    <BsTextareaResize />
  </button>
</div>

      {loading ? (
        <CargandoSpinner />
      ) : (
        <ReactFlow
  nodes={nodes}
  edges={edges}
  onNodesChange={onNodesChange}
  onEdgesChange={onEdgesChange}
  onConnect={onConnect}
  nodesDraggable={false}
  nodesConnectable={false}
  elementsSelectable={false}
  zoomOnScroll={false}
  panOnScroll={false}
  panOnDrag={false}
  zoomOnPinch={false}
  preventScrolling={false}
  fitView
  style={{ backgroundColor: '#F7F9FB' }}
>
          {/* <Controls /> */}

          <Background />
        </ReactFlow>
      )}
    </div>
  );
}

export default Workflow;
